module.exports = __webpack_public_path__ + "media/Video 60.291f9636.mp4";